module.exports = function() {
  return new Worker(__webpack_public_path__ + "f2540d3b8c519e35361a.worker.js");
};